export function downloadVCF (url, isStandalone) {
  if (isStandalone) {
    window.location.href = url
    return
  }

  const win = window.open(url, '_blank')
  if (win) win.focus()
}



// WEBPACK FOOTER //
// ./scripts/src/helpers/vcf.helper.js